import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ProvidehttpService } from '../providehttp.service';
import { ServiceStock } from '../service-stock.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit, OnDestroy {

  announcements: any = [];
  loginCategory = ""
  loginPageHeader = "LoginPage.login"; //"Login";

  constructor(private router: Router, private services: ServiceStock) {
    this.services.modal.dismissAll();
  }

  ngOnInit() {
    // this.router.navigate(['/login', 'elogin']);
    // this.loadannouncements();
    document.getElementById('pageBody').classList.add("body-login-page");
    this.loginCategory = "loginForm";
  }

  ngOnDestroy() {
    document.getElementById('pageBody').classList.remove("body-login-page");
  }

  login() {
    this.router.navigate(['/home']);
  }

  myIndex = 0;

  handleLogin(event) {
    this.loginCategory = event;
    if (event == "loginForm") {
      this.loginPageHeader = "LoginPage.login";
    }
    else if (event == "passwordChange") {
      this.loginPageHeader = "LoginPage.changePassword";
    }
    else {
      this.loginPageHeader = "LoginPage.unlockAccount";
    }
  }
}
